<template>
  <section>
    <b-modal width="680px" :active.sync="isModalTagEditActive" :on-cancel="closeTagEditModal">
      <!-- タグ編集エリア -->
      <TemplateTagEdit
        :isTagProgress="isTagProgress"
        :targetObj="targetObj"
        :currentTagList="currentTagList"
        :defaultTagList="defaultTagList"
        @addTag="addTag"
        @deleteTag="deleteTag"
      />
    </b-modal>
  </section>
</template>

<script>
import TemplateTagEdit from '@/components/organisms/templates/TemplateTagEdit'

export default {
  name: 'ModalTagEdit',
  componentName: 'ModalTagEdit',
  components: {
    TemplateTagEdit
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isModalTagEditActive: this.isTagEditModalOpen,
    }
  },
  props: {
    /** タグ編集モーダル開閉フラグ */
    isTagEditModalOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** タグ編集中フラグ */
    isTagProgress : {
      type    : Boolean,
      default : false,
      required: true
    },
    /** 親オブジェクト */
    targetObj: {
      required: true
    },
    /** デフォルトタグリスト */
    defaultTagList: {
      required: true
    },
    /** 親タグリスト */
    currentTagList: {
      required: true
    }
  },
  watch: {
    /** タグ編集モーダル開閉フラグ */
    isTagEditModalOpen () {
      this.isModalTagEditActive = this.isTagEditModalOpen
    },
  },
  methods: {
    /** タグ追加 */
    addTag (targetObj, addTagName){
      this.$emit('addTag', targetObj, addTagName)
    },
    /** タグ削除 */
    deleteTag(delTag){
      this.$emit('deleteTag', delTag)
    },
    /** タグ編集モーダルクローズ */
    closeTagEditModal () {
      this.$emit('closeTagEditModal')
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/common/ModalTagEdit.vue